var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-pro" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.data,
            height: _vm.height,
            border: _vm.border,
            stripe: _vm.stripe,
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": _vm.handleSortChange,
          },
        },
        [
          _vm.selection
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.index
            ? _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center",
                  index: _vm.indexMethod,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.columns, function (col) {
            return _c("el-table-column", {
              key: col.prop,
              attrs: {
                prop: col.prop,
                label: col.label,
                width: col.width,
                "min-width": col.minWidth,
                fixed: col.fixed,
                align: col.align || "left",
                sortable: col.sortable,
                "show-overflow-tooltip": col.tooltip !== false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        col.headerSlot
                          ? _vm._t(
                              "header-" + col.prop,
                              function () {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(col.label) +
                                      "\n        "
                                  ),
                                ]
                              },
                              { column: col, scope: scope }
                            )
                          : _c("span", [_vm._v(_vm._s(col.label))]),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        col.slot
                          ? _vm._t(col.slot, null, {
                              row: scope.row,
                              index: scope.$index,
                              column: col,
                            })
                          : col.type === "tag"
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getTagType(
                                    scope.row[col.prop],
                                    col
                                  ),
                                  size: col.tagSize || "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.getTagLabel(scope.row[col.prop], col)
                                    ) +
                                    "\n        "
                                ),
                              ]
                            )
                          : col.type === "status"
                          ? _c(
                              "span",
                              {
                                class: [
                                  "status-dot",
                                  _vm.getStatusType(scope.row[col.prop], col),
                                ],
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.getTagLabel(scope.row[col.prop], col)
                                    ) +
                                    "\n        "
                                ),
                              ]
                            )
                          : col.type === "image"
                          ? _c("el-image", {
                              style: {
                                width: col.imgWidth || "60px",
                                height: col.imgHeight || "60px",
                              },
                              attrs: {
                                src: scope.row[col.prop],
                                "preview-src-list":
                                  col.preview !== false
                                    ? [scope.row[col.prop]]
                                    : [],
                                fit: col.fit || "cover",
                              },
                            })
                          : col.type === "date"
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.formatDate(
                                      scope.row[col.prop],
                                      col.dateFormat || "yyyy-MM-dd"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : col.type === "money"
                          ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                              _vm._v(
                                "\n          ¥" +
                                  _vm._s(_vm.formatMoney(scope.row[col.prop])) +
                                  "\n        "
                              ),
                            ])
                          : col.type === "action"
                          ? _vm._l(col.actions, function (btn) {
                              return _c(
                                "el-button",
                                {
                                  key: btn.key,
                                  attrs: {
                                    type: "text",
                                    size: btn.size || "small",
                                    disabled: btn.disabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAction(
                                        btn,
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(btn.label) +
                                      "\n          "
                                  ),
                                ]
                              )
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row[col.prop]))]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPagination
        ? _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _vm.selection
                ? _c(
                    "div",
                    { staticClass: "selection-info" },
                    [
                      _vm._v("\n      已选择 "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#409EFF",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v(_vm._s(_vm.selectedRows.length))]
                      ),
                      _vm._v(" 项\n      "),
                      _vm.selectedRows.length > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: { click: _vm.clearSelection },
                            },
                            [_vm._v("清空选择")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-pagination", {
                staticClass: "pagination",
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  "page-sizes": _vm.pageSizes,
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }